import React from "react";
import {withNamespaces} from "react-i18next";
import {Button, Spinner} from "react-bootstrap";
import HilightTable from "../../../../../components/HilightTable";
import {Link} from "react-router-dom";
import DaliHelvarGroupForm from "../_forms/DaliHelvarGroupForm";
import {modalActions} from "../../../../../actions/modal.actions";
import {connect} from "react-redux";
import {daliHelvarActions} from "../../../../../actions/dali-helvar.actions";

const DaliHelvarGroupTable = ({t, list, device, area, showModal, editHelvarGroup, removeHelvarGroup}) => {

    const openModalEditGroup = (row) => {
        showModal({
            open: true,
            title: t('edit_dali-group'),
            component: <DaliHelvarGroupForm data={row} submitForm={(model) => editHelvarGroup(model)}/>
        }, "formModal");
    };

    const openModalDeleteGroup = (row) => {

        showModal({
            open: true,
            title: t('are-you-sure'),
            message: t('delete-msg') + `<h5> ${row.label} </h5>`,
            confirmLabel: t('delete-btn'),
            confirmIcon: 'fa-trash',
            classNameBtnConfirm: 'btn-danger',
            dataId: row.id,
            confirmAction: () => {
                removeHelvarGroup(row.id, row.networkDeviceId);
            },
        }, 'confirm');
    };

    const columns = [
        {
            Header: 'group-number',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            accessor: 'groupNumber'
        },
        {
            Header: 'label',
            accessor: 'label'
        },
        {
            Header: 'description',
            accessor: 'description'
        },
        {
            Header: 'actions',
            headerClassName: "text-right",
            classNameRow: 'text-right',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            Cell: (props) => {
                const row = props.row.original;
                return (
                    <React.Fragment>
                        <Link to={`/panel/network-device/dali/helvar/${device?.id}/scenes/${area?.id}/${row.id}`}>
                            <Button
                                className="mx-1"
                                variant={"info"}
                            >
                                <i className="fas fa-lightbulb" /> &nbsp;
                                {t('scenes')}
                            </Button>
                        </Link>
                        <Button className="mx-1" variant={"primary"} onClick={() => openModalEditGroup(row)}>
                            <i className="fas fa-edit" />
                        </Button>
                        <Button className="mx-1" variant={"danger"} onClick={() => openModalDeleteGroup(row)}>
                            <i className="fas fa-trash" />
                        </Button>
                    </React.Fragment>
                )
            }
        }
    ];

    const tableResult = (
        list ?
            list.length === 0 ? (
                <div className="text-center p-4">
                    <h3>{t('dali-group-no-content')}</h3>
                </div>
            ) : (
                <HilightTable
                    columns={columns}
                    data={list}
                />
            ) : (
                <React.Fragment>
                    <Spinner animation={"border"} />
                    <p>Loading ...</p>
                </React.Fragment>
            )
    );

    return (
        <div className="col-md-12 mx-0 my-3 p-0">
            { tableResult }
        </div>
    );
};

const mapDispatchToProps = dispatch => ({
    hideModal: () => dispatch(modalActions.hideModal()),
    showModal: (modalProps, modalType) => {
        dispatch(modalActions.showModal({modalProps, modalType}))
    },
    editHelvarGroup: (groupModel) => {
        dispatch(daliHelvarActions.editHelvarGroup(groupModel))
    },
    removeHelvarGroup: (groupId, networkDeviceId) => {
        dispatch(daliHelvarActions.deleteHelvarGroup(groupId, networkDeviceId))
    }
});
export default withNamespaces()(connect(null, mapDispatchToProps)(DaliHelvarGroupTable));
